import script from "./MatchinPayScanQR.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchinPayScanQR.vue?vue&type=script&setup=true&lang=js"

import "./MatchinPayScanQR.vue?vue&type=style&index=0&id=07b6f60c&lang=css"

export default script